import { Material, Province } from "types/canvasTypes";

/**
 * Attachment variant data for all materials across different stores (BC, GR, RF)
 * Each attachment has variant IDs for both black and silver finishes
 */

export const ATTACHMENT_VARIANTS = {
  [Material.AdjustableAttachement]: {
    material: Material.AdjustableAttachement,
    bcVariantBlackId: 'gid://shopify/ProductVariant/55237351211377',
    bcVariantSilverId: 'gid://shopify/ProductVariant/55237351145841',
    grVariantBlackId: 'gid://shopify/ProductVariant/44316447080633',
    grVariantSilverId: 'gid://shopify/ProductVariant/44316447015097',
    rfVariantBlackId: 'gid://shopify/ProductVariant/46272748028068',
    rfVariantSilverId: 'gid://shopify/ProductVariant/46272747962532',
    costBlack: new Map([
      [Province.Quebec, 38],
      [Province.Ontario, 38],
    ]),
    costSilver: new Map([
      [Province.Quebec, 35],
      [Province.Ontario, 35],
    ]),
  },
  [Material.Pannel90Attachemnt]: {
    material: Material.Pannel90Attachemnt,
    bcVariantBlackId: 'gid://shopify/ProductVariant/55237350916465',
    bcVariantSilverId: 'gid://shopify/ProductVariant/55237350850929',
    grVariantBlackId: 'gid://shopify/ProductVariant/44316446294201',
    grVariantSilverId: 'gid://shopify/ProductVariant/44316446228665',
    rfVariantBlackId: 'gid://shopify/ProductVariant/46272746815652',
    rfVariantSilverId: 'gid://shopify/ProductVariant/46272746750116',
    costBlack: new Map([
      [Province.Quebec, 28],
      [Province.Ontario, 28],
    ]),
    costSilver: new Map([
      [Province.Quebec, 25],
      [Province.Ontario, 25],
    ]),
  },
  [Material.WallAttachment]: {
    material: Material.WallAttachment,
    bcVariantBlackId: 'gid://shopify/ProductVariant/55237351047537',
    bcVariantSilverId: 'gid://shopify/ProductVariant/55237350982001',
    grVariantBlackId: 'gid://shopify/ProductVariant/44316446916793',
    grVariantSilverId: 'gid://shopify/ProductVariant/44316446851257',
    rfVariantBlackId: 'gid://shopify/ProductVariant/46272747536548',
    rfVariantSilverId: 'gid://shopify/ProductVariant/46272747471012',
    costBlack: new Map([
      [Province.Quebec, 28],
      [Province.Ontario, 28],
    ]),
    costSilver: new Map([
      [Province.Quebec, 25],
      [Province.Ontario, 25],
    ]),
  },
  [Material.Spigots]: {
    material: Material.Spigots,
    bcVariantBlackId: 'gid://shopify/ProductVariant/55237299732849',
    bcVariantSilverId: 'gid://shopify/ProductVariant/55237299700081',
    grVariantBlackId: 'gid://shopify/ProductVariant/44316441739449',
    grVariantSilverId: 'gid://shopify/ProductVariant/44316441706681',
    rfVariantBlackId: 'gid://shopify/ProductVariant/46272741015716',
    rfVariantSilverId: 'gid://shopify/ProductVariant/46272740982948',
    costBlack: new Map([
      [Province.Quebec, 70],
      [Province.Ontario, 79],
    ]),
    costSilver: new Map([
      [Province.Quebec, 66],
      [Province.Ontario, 69],
    ]),
  },
  [Material.Pannel180Attachemnt]: {
    material: Material.Pannel180Attachemnt,
    bcVariantBlackId: 'gid://shopify/ProductVariant/55237350785393',
    bcVariantSilverId: 'gid://shopify/ProductVariant/55237350719857',
    grVariantBlackId: 'gid://shopify/ProductVariant/44316446163129',
    grVariantSilverId: 'gid://shopify/ProductVariant/44316446097593',
    rfVariantBlackId: 'gid://shopify/ProductVariant/46272746520740',
    rfVariantSilverId: 'gid://shopify/ProductVariant/46272746455204',
    costBlack: new Map([
      [Province.Quebec, 28],
      [Province.Ontario, 28],
    ]),
    costSilver: new Map([
      [Province.Quebec, 25],
      [Province.Ontario, 25],
    ]),
  },
  [Material.DoorLatch]: {
    material: Material.DoorLatch,
    bcVariantBlackId: 'gid://shopify/ProductVariant/55237300486513',
    bcVariantSilverId: 'gid://shopify/ProductVariant/55237300453745',
    grVariantBlackId: 'gid://shopify/ProductVariant/44316447244473',
    grVariantSilverId: 'gid://shopify/ProductVariant/44316447211705',
    rfVariantBlackId: 'gid://shopify/ProductVariant/46272748716196',
    rfVariantSilverId: 'gid://shopify/ProductVariant/46272748683428',
    costBlack: new Map([
      [Province.Quebec, 85],
      [Province.Ontario, 175],
    ]),
    costSilver: new Map([
      [Province.Quebec, 75],
      [Province.Ontario, 150],
    ]),
  },
  [Material.FloorLock]: {
    material: Material.FloorLock,
    bcVariantBlackId: 'gid://shopify/ProductVariant/55237300879729',
    bcVariantSilverId: 'gid://shopify/ProductVariant/55237300846961',
    grVariantBlackId: 'gid://shopify/ProductVariant/44316524773561',
    grVariantSilverId: 'gid://shopify/ProductVariant/44316524740793',
    rfVariantBlackId: 'gid://shopify/ProductVariant/46272749535396',
    rfVariantSilverId: 'gid://shopify/ProductVariant/46272749502628',
    costBlack: new Map([
      [Province.Quebec, 120],
      [Province.Ontario, 120],
    ]),
    costSilver: new Map([
      [Province.Quebec, 100],
      [Province.Ontario, 100],
    ]),
  },
  [Material.HingeKit]: {
    material: Material.HingeKit,
    bcVariantBlackId: 'gid://shopify/ProductVariant/55237299994993',
    bcVariantSilverId: 'gid://shopify/ProductVariant/55237299929457',
    grVariantBlackId: 'gid://shopify/ProductVariant/44316447178937',
    grVariantSilverId: 'gid://shopify/ProductVariant/44316447146169',
    rfVariantBlackId: 'gid://shopify/ProductVariant/46272748454052',
    rfVariantSilverId: 'gid://shopify/ProductVariant/46272748421284',
    costBlack: new Map([
      [Province.Quebec, 280],
      [Province.Ontario, 275],
    ]),
    costSilver: new Map([
      [Province.Quebec, 200],
      [Province.Ontario, 250],
    ]),
  },
} as const;
